import {
  ADD_AI_MSG,
  ADD_AI_MSG_SUCCESS,
  ADD_AI_MSG_FAILURE,
  GET_AI_MSGS,
  GET_AI_MSGS_SUCCESS,
  GET_AI_MSGS_FAILURE,
  GET_AI_SESSIONS,
  GET_AI_SESSIONS_SUCCESS,
  GET_AI_SESSIONS_FAILURE,
  GET_AI_DOCS,
  GET_AI_DOCS_SUCCESS,
  GET_AI_DOCS_FAILURE,
  DELETE_AI_SESSION,
  DELETE_AI_SESSION_SUCCESS,
  DELETE_AI_SESSION_FAILURE,
} from "../constants";

const initialState = {
  aiMessages: [],
  aiSessions: [],
  aiDocs: [],
  isSessionsLoading: false,
  isAddLoading: false,
  isDeleteLoading: false,
  isMessagesLoading: false,
  isDocsLoading: false,
  error: null,
};

export default function AIReducer(state = initialState, action) {
  switch (action.type) {
    case GET_AI_MSGS:
      state = {
        ...state,
        isMessagesLoading: true,
        error: null,
      };
      break;
    case ADD_AI_MSG:
      state = {
        ...state,
        isAddLoading: true,
        error: null,
      };
      break;
    case GET_AI_SESSIONS:
      state = {
        ...state,
        isSessionsLoading: true,
        error: null,
      };
      break;
    case DELETE_AI_SESSION:
      state = {
        ...state,
        isDeleteLoading: true,
        error: null,
      };
      break;
    case GET_AI_DOCS:
      state = {
        ...state,
        isDocsLoading: true,
        error: null,
      };
      break;
    case GET_AI_SESSIONS_SUCCESS:
      state = {
        ...state,
        aiSessions: action.payload,
        isSessionsLoading: false,
      };
      break;
    case DELETE_AI_SESSION_SUCCESS:
      state = {
        ...state,
        isDeleteLoading: false,
      };
      break;
    case GET_AI_DOCS_SUCCESS:
      state = {
        ...state,
        aiDocs: action.payload,
        isDocsLoading: false,
      };
      break;
    case GET_AI_MSGS_SUCCESS:
      state = {
        ...state,
        aiMessages: action.payload,
        isMessagesLoading: false,
      };
      break;
    case ADD_AI_MSG_SUCCESS:
      state = {
        ...state,
        isAddLoading: false,
      };
      break;
    case GET_AI_MSGS_FAILURE:
      state = {
        ...state,
        aiMessages: [],
        isMessagesLoading: false,
      };
      break;
    case GET_AI_SESSIONS_FAILURE:
      state = {
        ...state,
        aiSessions: [],
        isSessionsLoading: false,
      };
      break;
    case DELETE_AI_SESSION_FAILURE:
      state = {
        ...state,
        isDeleteLoading: false,
      };
      break;
    case GET_AI_DOCS_FAILURE:
      state = {
        ...state,
        aiDocs: [],
        isDocsLoading: false,
      };
      break;
    case ADD_AI_MSG_FAILURE:
      state = {
        ...state,
        isAddLoading: false,
      };
      break;
    default:
      break;
  }
  return state;
}
